import React, { memo } from 'react';

const AboutPage = () => {
  return <div>Under construction</div>;
}

export default memo(AboutPage);
